import UserAvatar from '@/components/UserAvatar'
import { isSmallScreenAtom } from '@/atoms/screenSize'
import { loadFollowsList } from '@nostr/gadgets/lists'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentPubkey } from '@/atoms/session'
import { useAtomValue } from 'jotai'

export default function FollowedBy({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const isSmallScreen = useAtomValue(isSmallScreenAtom)
  const [followedBy, setFollowedBy] = useState<string[]>([])
  const accountPubkey = useCurrentPubkey()
  useEffect(() => {
    if (!pubkey || !accountPubkey) return

    const init = async () => {
      const followings = (await loadFollowsList(accountPubkey)).items.reverse()
      const followingsOfFollowings = await Promise.all(
        followings.map(async (following) => {
          return (await loadFollowsList(following)).items
        })
      )
      const _followedBy: string[] = []
      const limit = isSmallScreen ? 3 : 5
      for (const [index, following] of followings.entries()) {
        if (following === pubkey) continue
        if (followingsOfFollowings[index].includes(pubkey)) {
          _followedBy.push(following)
        }
        if (_followedBy.length >= limit) {
          break
        }
      }
      setFollowedBy(_followedBy)
    }
    init()
  }, [pubkey, accountPubkey])

  if (followedBy.length === 0) return null

  return (
    <div className="flex items-center gap-1 mt-2">
      <div className="text-muted-foreground">{t('Followed by')}</div>
      {followedBy.map((p) => (
        <UserAvatar user={p} key={p} size="xSmall" />
      ))}
    </div>
  )
}
